import React from 'react'
import { Button } from '@surecompanies/core_components'
import { Tooltip } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { UserStatusBucket } from '../../api/dto/user-invitation.dto'
import { ShowingCount } from '../shared/finance.styles'
import { NoCompanyLink, ShowingBar } from './UserManagement.styles'

interface ShowingLineProps {
  page: number
  pageSize: number
  total: number
  /** Role holders no active billing profile lists, within the other filters. */
  noCompanyCount: number
  statusFilters: UserStatusBucket[]
  onReviewNoCompany: () => void
  onShowAllUsers: () => void
}

const LEFTOVER_ACCESS = 'They keep portal access until the role is removed.'

/**
 * What the table is showing, and the one place the roster owns up to leftover
 * access. Narrowing to those rows hides every other row, so the line says so
 * and carries the way back.
 */
const ShowingLine = ({
  page,
  pageSize,
  total,
  noCompanyCount,
  statusFilters,
  onReviewNoCompany,
  onShowAllUsers,
}: ShowingLineProps) => {
  if (total === 0) return null

  const isShowingOnly =
    statusFilters.length === 1 && statusFilters[0] === 'NO_COMPANIES'
  // Listed among other statuses: already on screen, and no filter of ours to
  // undo.
  const hasLeftoverAccess =
    noCompanyCount > 0 && !statusFilters.includes('NO_COMPANIES')

  return (
    <ShowingBar>
      <span>
        Showing{' '}
        <ShowingCount>
          {Math.min((page - 1) * pageSize + 1, total)}–
          {Math.min(page * pageSize, total)}
        </ShowingCount>{' '}
        of <ShowingCount>{total}</ShowingCount> users
        {isShowingOnly ? ` with no company. ${LEFTOVER_ACCESS}` : null}
      </span>

      {isShowingOnly ? (
        <Button size="small" onClick={onShowAllUsers}>
          Show all users
        </Button>
      ) : null}

      {hasLeftoverAccess ? (
        <Tooltip
          title={`Finance Managers with nothing to invoice. ${LEFTOVER_ACCESS}`}
        >
          <NoCompanyLink type="button" onClick={onReviewNoCompany}>
            <WarningOutlined />
            {noCompanyCount} with no company
          </NoCompanyLink>
        </Tooltip>
      ) : null}
    </ShowingBar>
  )
}

export { ShowingLine }
